import script from "./HandyServe.vue?vue&type=script&setup=true&lang=js"
export * from "./HandyServe.vue?vue&type=script&setup=true&lang=js"

import "./HandyServe.vue?vue&type=style&index=0&id=5c39523c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c39523c"]])

export default __exports__